interface UseDebugReturn {
  log: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
  error: (...args: unknown[]) => void
  startTimer: () => Timer
}

interface Timer {
  stop: () => void
  getElapsedTime: () => number
  logElapsedTime: () => void
  stopAndLog: () => void
}

export const useDebug = (isEnabled = false): UseDebugReturn => {
  const getTimestamp = (): string => {
    return `[${new Date().getTime()}]`
  }

  const createTimer = (): Timer => {
    const startTime = new Date().getTime()
    let stopTime: number | null = null

    const stop = (): void => {
      stopTime = new Date().getTime()
    }

    const getElapsedTime = (): number => {
      const currentTime = new Date().getTime()
      return stopTime ? (stopTime - startTime) / 1000 : (currentTime - startTime) / 1000
    }

    const logElapsedTime = (): void => {
      if (isEnabled) {
        console.log(getTimestamp(), `Elapsed time: ${getElapsedTime()} seconds`)
      }
    }

    return {
      stop,
      getElapsedTime,
      logElapsedTime,
      stopAndLog: () => {
        stop()
        logElapsedTime()
      }
    }
  }

  return {
    log: (...args: unknown[]): void => {
      if (isEnabled) {
        console.log(getTimestamp(), ...args)
      }
    },
    info: (...args: unknown[]): void => {
      if (isEnabled) {
        console.info(getTimestamp(), ...args)
      }
    },
    warn: (...args: unknown[]): void => {
      if (isEnabled) {
        console.warn(getTimestamp(), ...args)
      }
    },
    error: (...args: unknown[]): void => {
      if (isEnabled) {
        console.error(getTimestamp(), ...args)
      }
    },
    startTimer: () => {
      return createTimer()
    }
  }
}
